import { render, staticRenderFns } from "./DatasetContactForm.vue?vue&type=template&id=1698874c&scoped=true&"
import script from "./DatasetContactForm.vue?vue&type=script&lang=js&"
export * from "./DatasetContactForm.vue?vue&type=script&lang=js&"
import style0 from "./DatasetContactForm.vue?vue&type=style&index=0&id=1698874c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1698874c",
  null
  
)

export default component.exports